import type { CrimeData } from "@/types/public-data"

const CRIME_LABELS: Record<string, string> = {
  "anti-social-behaviour": "Anti-social behaviour",
  "bicycle-theft": "Bicycle theft",
  burglary: "Burglary",
  "criminal-damage-arson": "Criminal damage & arson",
  drugs: "Drugs",
  "other-crime": "Other crime",
  "other-theft": "Other theft",
  "possession-of-weapons": "Possession of weapons",
  "public-order": "Public order",
  robbery: "Robbery",
  shoplifting: "Shoplifting",
  "theft-from-the-person": "Theft from the person",
  "vehicle-crime": "Vehicle crime",
  "violent-crime": "Violence & sexual offences",
}

interface CrimeCardProps {
  data: CrimeData
}

export default function CrimeCard({ data }: CrimeCardProps) {
  const topCategories = [...data.categories]
    .sort((a, b) => b.count - a.count)
    .slice(0, 5)

  const maxCount = topCategories.length > 0 ? topCategories[0].count : 1

  return (
    <div className="rounded-xl border border-stone bg-white p-6">
      <h3 className="font-display text-lg font-semibold text-charcoal">
        Crime
      </h3>

      <div className="mt-3 flex items-baseline gap-2">
        <span className="text-2xl font-bold text-charcoal">
          {data.totalCrimes.toLocaleString()}
        </span>
        <span className="text-sm text-slate">total crimes</span>
      </div>

      <p className="mt-1 text-xs text-slate">Month: {data.month}</p>

      {topCategories.length > 0 && (
        <div className="mt-4 space-y-2">
          {topCategories.map((cat) => (
            <div key={cat.category}>
              <div className="flex items-center justify-between text-sm">
                <span className="text-slate">
                  {CRIME_LABELS[cat.category] ?? cat.category}
                </span>
                <span className="font-medium text-charcoal">{cat.count}</span>
              </div>
              <div className="mt-1 h-1.5 w-full rounded-full bg-stone">
                <div
                  className="h-1.5 rounded-full bg-charcoal"
                  style={{ width: `${(cat.count / maxCount) * 100}%` }}
                />
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  )
}
